import { FileText, Users, Wand2, Lightbulb, Sparkles } from "lucide-react";
import type { LessonOption, TipoAula, Dificuldade } from "./types";

export const DEFAULT_STUDENTS_COUNT = 30;
export const DEFAULT_DURATION: "60" = "60";
export const DEFAULT_LESSON_TYPE: TipoAula = "hibrida";
export const DEFAULT_DIFFICULTY: Dificuldade = "intermediaria";

export const DEFAULT_CLASSES = [
  "6º Ano",
  "7º Ano",
  "8º Ano",
  "9º Ano",
  "1º Ano EM",
  "2º Ano EM",
  "3º Ano EM",
];

export const LESSON_TYPE_OPTIONS: LessonOption[] = [
  { value: "expositiva", label: "Expositiva", icon: FileText },
  { value: "discussao", label: "Discussão", icon: Users },
  { value: "pratica", label: "Prática", icon: Wand2 },
  { value: "projeto", label: "Projeto", icon: Lightbulb },
  { value: "hibrida", label: "Híbrida", icon: Sparkles },
];

export const DIFFICULTY_OPTIONS: LessonOption[] = [
  { value: "basica", label: "Básica" },
  { value: "intermediaria", label: "Intermediária" },
  { value: "avancada", label: "Avançada" },
];

export const DURATION_OPTIONS: LessonOption[] = [
  { value: "45", label: "45 minutos" },
  { value: "60", label: "60 minutos" },
  { value: "90", label: "90 minutos" },
  { value: "120", label: "120 minutos" },
];

export const DIFFICULTY_MAP: Record<Dificuldade, string> = {
  basica: "Básica",
  intermediaria: "Intermediária",
  avancada: "Avançada",
};

export const LESSON_TYPE_MAP: Record<TipoAula, string> = {
  expositiva: "Expositiva",
  discussao: "Discussão",
  pratica: "Prática",
  projeto: "Projeto",
  hibrida: "Híbrida",
};

export const MESSAGES = {
  VALIDATION: {
    SUBJECT_REQUIRED: "Por favor, selecione uma matéria!",
    GRADE_REQUIRED: "Por favor, selecione uma série/turma!",
    TOPIC_REQUIRED: "Por favor, informe o tópico principal!",
  },
  ERROR: {
    UNKNOWN: "Erro desconhecido ao gerar aula",
    CONNECTION:
      "Não foi possível conectar ao servidor. Verifique se a API está rodando na porta 8000.",
    TIMEOUT: "A requisição demorou muito. Tente novamente.",
    GENERATION_FAILED: "Erro ao gerar plano de aula",
  },
  SUCCESS: {
    SAVED: "Aula salva com sucesso!",
    COPIED: "Conteúdo da aula copiado para a área de transferência!",
  },
  LOADING: "Preparando requisição...",
  LOADING_SENDING: "Enviando dados para a IA...",
  LOADING_PROCESSING: "Processando resposta da IA...",
  LOADING_HINT: "Isso pode levar de 10 a 60 segundos...",
  TIP: "Dica: Quanto mais detalhes você fornecer, mais personalizada será sua aula!",
};

export const FALLBACK_OBJECTIVES = [
  "Identificar e compreender os conceitos apresentados",
  "Aplicar o conhecimento em situações práticas",
  "Desenvolver habilidades de análise e síntese",
];

export const FALLBACK_ACTIVITIES = [
  "Explicação teórica dos conceitos",
  "Exemplos práticos",
  "Análise de casos",
  "Discussão em grupo",
];

export const FALLBACK_MATERIALS = [
  "Projetor e computador",
  "Material didático impresso",
  "Quadro branco e marcadores",
  "Recursos multimídia relacionados ao tema",
];

export const EXPORT_CONFIG = {
  FORMAT: "EduAI Lesson Plan",
  VERSION: "2.1",
};
